<div class="widget-domain-switcher-container">
    <h3>{{'footer.internationale'|T}}</h3>
    @for(country of countries; track country.id){
        <a [href]="country.route" class="country-link d-inline-block">
            <img [src]="country.img" [alt]="country.flagCode" class="country-img" loading="lazy">
        </a>
    }

</div>